import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export const root = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(5)};
`

// Two columns on desktop; wraps so the card stacks under the dropzone on narrow
// viewports. The dropzone column grows; the card column has a fixed-ish basis.
export const columns = css`
  display: flex;
  align-items: flex-start;
  gap: ${spacing(6)};
  flex-wrap: wrap;
`

export const mainColumn = css`
  flex: 1 1 360px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${spacing(5)};
`

// Layout-only wrapper — the PrepareCsvCard owns its own surface/border/padding.
export const aside = css`
  flex: 0 0 340px;
  max-width: 100%;
`
